

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.a1bb5446.js","_app/immutable/chunks/scheduler.85e01571.js","_app/immutable/chunks/index.a7ffdff2.js","_app/immutable/chunks/singletons.ff74dc28.js","_app/immutable/chunks/index.282274ee.js"];
export const stylesheets = [];
export const fonts = [];
